import { Skeleton } from '@material-ui/lab'
import React from 'react'

const TableItemSkelton = ({height,width}) => {
  return (
    <Skeleton height={height || "25px"} width={width || "100%"} animation="wave" />
  )
}

export default TableItemSkelton